import api from "./api"

export const getPurchaseOrderFormData = async () => {
  const response = await api.get("/purchase-orders/form-data")
  return response.data
}

export const getPurchaseOrders = async () => {
  const response = await api.get("/purchase-orders")
  return response.data
}

export const getPurchaseOrderById = async (orderId) => {
  const response = await api.get(`/purchase-orders/${orderId}`)
  return response.data
}

export const createPurchaseOrder = async (payload) => {
  const response = await api.post("/purchase-orders", payload)
  return response.data
}

export const approvePurchaseOrder = async (orderId, payload = {}) => {
  const response = await api.post(
    `/purchase-orders/${orderId}/approve`,
    payload
  )
  return response.data
}

export const sendPurchaseOrder = async (orderId, payload = {}) => {
  const response = await api.post(`/purchase-orders/${orderId}/send`, payload)
  return response.data
}

export const cancelPurchaseOrder = async (orderId, payload = {}) => {
  const response = await api.post(
    `/purchase-orders/${orderId}/cancel`,
    payload
  )
  return response.data
}